import axios from "axios";

const API_BASE = process.env.REACT_APP_BACKEND_URL || "";

const client = axios.create({
  baseURL: `${API_BASE}/api`,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Auth endpoints that should never trigger a refresh retry
const AUTH_PATHS = ["/auth/me", "/auth/login", "/auth/register", "/auth/refresh", "/auth/logout"];

client.interceptors.response.use(
  (res) => res,
  async (error) => {
    const url = error.config?.url || "";
    const isAuthEndpoint = AUTH_PATHS.some((p) => url.includes(p));
    if (error.response?.status === 401 && !error.config._retry && !isAuthEndpoint) {
      error.config._retry = true;
      try {
        await axios.post(`${API_BASE}/api/auth/refresh`, {}, { withCredentials: true });
        return client(error.config);
      } catch {
        // Refresh failed — just reject, let the component handle it
      }
    }
    return Promise.reject(error);
  }
);

export default client;

export function formatApiError(error) {
  const detail = error?.response?.data?.detail;
  if (!detail) return error?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}
